export const AP_STATUS = [
    { codigo: '', label: 'Aguardando Aprovação' },
    { codigo: '*', label: 'Aguardando Aprovação Cliente' },
    { codigo: 'A', label: 'Aprovado' },
    { codigo: 'P', label: 'Aprovado mas Não Faturar' },
    { codigo: 'N', label: 'Não Aprovado' },
    { codigo: 'S', label: 'Suspenso' },
    { codigo: 'L', label: 'Liberado para Faturamento' },
    { codigo: 'F', label: 'Faturado' },
    { codigo: 'C', label: 'Cancelado' },
    { codigo: 'O', label: 'Fechado' },
    { codigo: 'R', label: 'Revisado' },
    { codigo: 'D', label: 'Recusado' },
];
const AP_STATUS_BY_CODIGO = new Map(AP_STATUS.map((s) => [s.codigo, s]));
/**
 * Mapa código → label mantido para retrocompatibilidade
 * (ex.: builder de filtros que itera o mapa como Record).
 */
export const ApStatusMap = Object.fromEntries(AP_STATUS.map((s) => [s.codigo, s.label]));
export function getApStatusDef(codigo) {
    return codigo == null ? AP_STATUS_BY_CODIGO.get('') : AP_STATUS_BY_CODIGO.get(codigo);
}
/** Texto amigável do status; para letras desconhecidas, devolve a própria letra. */
export function getApStatusLabel(codigo) {
    const def = getApStatusDef(codigo);
    if (def)
        return def.label;
    return codigo?.trim() ? codigo : 'Aguardando Aprovação';
}
/**
 * Códigos de status que indicam AP já aprovada/faturável — Aprovado (A),
 * Aprovado mas Não Faturar (P), Liberado para Faturamento (L), Faturado (F) e
 * Fechado (O). Espelha `AP_STATUS_PERMITE_VINCULO_PLANILHA` do backend
 * (domain/enums/ap-status.enum.ts).
 */
export const AP_STATUS_APROVADOS = ['A', 'P', 'L', 'F', 'O'];
/** `true` quando a AP já está em um status aprovado/faturável. */
export function apStatusAprovado(codigo) {
    return codigo != null && AP_STATUS_APROVADOS.includes(codigo);
}
